import { useQuery } from "@tanstack/react-query"
import { GETBankAccount } from "../requests"


export const BANK_ACCOUNT_QUERY_KEY = ['bankAccount']

export const useGetBankAccount = () => {
    
    
    return useQuery({
        refetchOnMount: "always",
        queryKey: [BANK_ACCOUNT_QUERY_KEY],
        queryFn: GETBankAccount,
    })

}